import { Component, Input, OnInit } from '@angular/core';
import { PayRateSetModel } from '@bayclubs/group-classes-employee-api';
import { TimeService } from '@bayclubs/utils';

import { Router } from '@angular/router';
import { InstructorsApiService } from '../../../shared/services/instructors.api.service';



@Component({	
    selector: 'app-provider-payrates-history',	
    templateUrl: './provider-payrates-history.component.html',	
    styleUrls: ['./provider-payrates-history.component.scss'],
    standalone: false
})	
export class ProviderPayratesHistoryComponent implements OnInit {	
    payRates: PayRateSetModel[];	

    @Input() providerId: string;	
    includeObsolete: boolean;	

    constructor(private instructors: InstructorsApiService, private time: TimeService, private router: Router) {}	

    ngOnInit() {	
        this.loadPayRates();	
    }	

    public refresh() {	
        this.loadPayRates();	
    }	

    loadPayRates() {	
        this.instructors.getPayRates(this.providerId, this.includeObsolete).subscribe(data => {	
            this.payRates = data.sort((a, b) => this.time.toMoment(b.validFrom).valueOf() - this.time.toMoment(a.validFrom).valueOf());	
        });	
    }	

    onIncludeObsoleteClick() {	
        this.loadPayRates();	
    }	

    backToTrainers() {
        this.router.navigate(['/trainers/list']);
    }
}	
